<div class="dashboard-events-calendar-widget">
  <div class="widget-toolbar">
    <button
      mat-icon-button
      type="button"
      aria-label="Fuld skærm"
      (click)="openFullscreen()"
    >
      <mat-icon>fullscreen</mat-icon>
    </button>
  </div>
  <app-duna-events-schedule
    #inlineSchedule
    [events]="events"
    [scheduleView]="scheduleView"
    [selectedDate]="selectedDate"
    [loading]="loading"
    [compact]="true"
    [categoryColors]="categoryColors"
    (visibleRangeChange)="onVisibleRangeChange($event)"
    (scheduleViewChange)="onScheduleViewChange($event)"
    (selectedDateChange)="onSelectedDateChange($event)"
    (eventClick)="onEventClick($event)"
  />
</div>

<ng-template #fullscreenTemplate>
  <div class="fullscreen-calendar-shell">
    <div class="fullscreen-toolbar">
      <span class="fullscreen-title">Begivenhedskalender</span>
      <button
        mat-icon-button
        type="button"
        aria-label="Luk fuld skærm"
        (click)="closeFullscreen()"
      >
        <mat-icon>fullscreen_exit</mat-icon>
      </button>
    </div>
    <app-duna-events-schedule
      [events]="events"
      [scheduleView]="scheduleView"
      [selectedDate]="selectedDate"
      [loading]="loading"
      [categoryColors]="categoryColors"
      (visibleRangeChange)="onVisibleRangeChange($event)"
      (scheduleViewChange)="onScheduleViewChange($event)"
      (selectedDateChange)="onSelectedDateChange($event)"
      (eventClick)="onEventClick($event)"
    />
  </div>
</ng-template>
